import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export const GroupedMenu = (props) => {
	const {
		className,
		children
	} = props;

	return (
		<div className={classNames(className, 'ads-grouped-menu')}>{children}</div>
	);
}

GroupedMenu.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

GroupedMenu.defaultProps = {
	className: '',
};
